<template lang="pug">
    div(class="_forma")
        template(v-for="(entry,i) in value")
            slot(:index="i")
</template>

<script>
    import object from './ib-form-object.vue';

    /**
     * An array within an `ib-form`.
     */
    export default {
        name: 'ib-form-array',

        mixins: [
            object
        ],

        props: {
            /**
             * Array of values to populate the form.
             */
            value: Array
        },

        data() {
            return {

                /**
                 * Computed object containing value of all form entries. We do not make this
                 * reactive, because we do not want to recompute every time someone presses a key
                 * in one field when there are many.
                 */
                get ivalue() {
                    return this.control.map(control => control.ivalue);
                }
            };
        }
    }
</script>
